import { gql } from "@apollo/client"

import { useMutation, InjectedOptions } from "@oysterhr/core"
import { TransitionEnrollmentInput, TransitionEnrollmentPayload } from "@oysterhr/schema"

const TRANSITION_ENROLLMENT_MUTATION = gql`
  mutation TransitionEnrollment(
    $enrollmentId: ID!
    $transitionEvent: BenefitsEnrollmentTransitionEventEnum!
    $coverageEndDate: ISO8601Date
    $cancellationReason: BenefitsEnrollmentCancellationReasonEnum
  ) {
    transitionEnrollment(
      input: {
        enrollmentId: $enrollmentId
        transitionEvent: $transitionEvent
        coverageEndDate: $coverageEndDate
        cancellationReason: $cancellationReason
      }
    ) {
      errors
      benefitEnrollment {
        id
        coverageEndDate
        state
        availableEvents
        coverageStartDate
        cancelledAt
        enrolledAt
        cancellationReason
      }
    }
  }
`

interface _TransitionEnrollmentPayload {
  transitionEnrollment: TransitionEnrollmentPayload
}

export const useTransitionEnrollment = (
  options?: InjectedOptions<_TransitionEnrollmentPayload, TransitionEnrollmentInput>,
) => {
  return useMutation<_TransitionEnrollmentPayload, TransitionEnrollmentInput>(
    TRANSITION_ENROLLMENT_MUTATION,
    {
      ...options,
    },
  )
}
